import React from 'react';
import { ProGalleryRenderer } from 'pro-gallery';
import { experimentsWrapper } from '@wix/photography-client-lib';
export var ProGalleryRendererWrapper = function (props) {
    var structure = props.structure;
    var container = props.container;
    var items = props.items;
    var scrollingElement = props.scrollingElement;
    var createMediaUrl = props.createMediaUrl;
    var eventsListener = props.eventsListener;
    var customComponents = props.customComponents;
    var getProGalleryRole = function () {
        var removeRoleApplication = experimentsWrapper.getExperimentBoolean('specs.pro-gallery.removeRoleApplication');
        if (removeRoleApplication) {
            return "region";
        }
        return "application";
    };
    return (React.createElement(ProGalleryRenderer, { key: "pro-gallery", id: props.id, structure: structure, container: container, isInDisplay: props.isInDisplay, options: props.options, items: items, totalItemsCount: props.totalItemsCount, deviceType: props.deviceType, viewMode: props.viewMode, scrollingElement: scrollingElement, createMediaUrl: createMediaUrl, isPrerenderMode: props.isPrerenderMode, customComponents: customComponents, eventsListener: eventsListener, settings: props.settings, proGalleryRole: getProGalleryRole(), translations: props.translations, enableExperimentalFeatures: props.enableExperimentalFeatures }));
};
//# sourceMappingURL=proGalleryRendererWrapper.js.map